import API from './api';

// data = { email: '' }
export const request = async (data: any) => await API.post(`/tokens/request`, data);